'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var destructure = function destructure(props) {
  var children = _react2['default'].Children.toArray(props.children);
  var rootIconIndex = children.findIndex(function (c) {
    return c.type.displayName === 'ActivityListItemIcon';
  });
  var rootIcon = rootIconIndex !== -1 ? children.splice(rootIconIndex, 1)[0] : null;
  var secondaryIconIndex = children.findIndex(function (c) {
    return c.type.displayName === 'ActivityListItemAvatar';
  });
  var secondaryIcon = secondaryIconIndex !== -1 ? children.splice(secondaryIconIndex, 1)[0] : null;

  return {
    children: children,
    rootIcon: rootIcon,
    secondaryIcon: secondaryIcon
  };
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ActivityListItemHeader', function (theme) {
  var borderBottom = '1px solid ' + theme.palette.text.lightDivider;

  return _defineProperty({
    root: Object.assign({
      display: 'flex',
      flexShrink: 0
    }, theme.mixins.gutters(2)),
    inner: _defineProperty({
      alignItems: 'flex-start',
      display: 'flex',
      flex: 1,
      flexFlow: 'column'
    }, theme.breakpoints.up('sm'), {
      alignItems: 'baseline',
      flexFlow: 'row'
    }),
    main: _defineProperty({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row-reverse',
      flex: 1,
      paddingTop: theme.typography.rhythmByUnit(2.5),
      paddingBottom: theme.typography.rhythmByUnit(2.5)
    }, theme.breakpoints.up('sm'), {
      flexFlow: 'row'
    }),
    divider: {
      borderBottom: borderBottom
    },
    fullscreenNoDivider: {
      borderBottom: 'none'
    },
    fullscreenDivider: {
      borderBottom: borderBottom
    },
    rootIconContainer: {
      alignItems: 'center',
      display: 'flex',
      marginRight: theme.typography.rhythmByUnit(2.5),
      height: theme.typography.rhythmByUnit(4),
      marginTop: theme.typography.rhythmByUnit(2.5),
      marginBottom: theme.typography.rhythmByUnit(2.5)
    },
    secondaryIconContainer: {
      alignSelf: 'flex-start'
    }
  }, theme.breakpoints.up('sm'), {
    fullscreenNoDivider: {
      borderBottom: borderBottom
    },
    fullscreenDivider: {
      borderBottom: 'none'
    },
    secondaryIconContainer: {
      paddingRight: theme.typography.rhythmByUnit(1.5)
    }
  });
});

var ActivityListItemHeader = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(ActivityListItemHeader, _React$PureComponent);

  function ActivityListItemHeader() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ActivityListItemHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ActivityListItemHeader.__proto__ || Object.getPrototypeOf(ActivityListItemHeader)).call.apply(_ref2, [this].concat(args))), _this), _this.state = destructure(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActivityListItemHeader, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(props) {
        if (props.children === this.props.children) return;
        this.setState(destructure(props)); // eslint-disable-line flowtype-errors/show-errors
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    // eslint-disable-line flowtype-errors/show-errors

    value: function () {
      function render() {
        var _props = this.props,
            childrenProp = _props.children,
            classNameProp = _props.className,
            Component = _props.component,
            fullScreen = _props.fullScreen,
            other = _objectWithoutProperties(_props, ['children', 'className', 'component', 'fullScreen']);

        var _state = this.state,
            children = _state.children,
            rootIcon = _state.rootIcon,
            secondaryIcon = _state.secondaryIcon; // eslint-disable-line flowtype-errors/show-errors

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.fullscreenDivider, fullScreen));
        var mainClassName = (0, _classnames2['default'])(classes.main, _defineProperty({}, classes.fullscreenNoDivider, fullScreen), classNameProp);

        return _react2['default'].createElement(
          'div',
          { className: rootClassName },
          rootIcon && _react2['default'].createElement(
            'div',
            { className: classes.rootIconContainer },
            rootIcon
          ),
          _react2['default'].createElement(
            Component,
            _extends({ className: mainClassName }, other),
            secondaryIcon && _react2['default'].createElement(
              'div',
              { className: classes.secondaryIconContainer },
              secondaryIcon
            ),
            _react2['default'].createElement(
              'div',
              { className: classes.inner },
              children
            )
          )
        );
      }

      return render;
    }()
  }]);

  return ActivityListItemHeader;
}(_react2['default'].PureComponent), _class.displayName = 'ActivityListItemHeader', _class.defaultProps = {
  component: 'div',
  fullScreen: false
}, _temp2);
exports['default'] = ActivityListItemHeader;


ActivityListItemHeader.contextTypes = {
  styleManager: _PropTypes2['default'].object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ActivityListItemHeader.js
// module id = 719
// module chunks = 32